import React, { useContext, useState } from 'react';

import './Newsletter.scss';
import ErrorModal from '../../UIElements/ErrorModal/ErrorModal';
import LoadingSpinner from '../../UIElements/LoadingSpinner/LoadingSpinner';
import { useHttpClient } from '../../../hooks/http-hook';
import { LanguageContext } from '../../../context/language-context';

const Newsletter = ({ className }) => {
  const lng = useContext(LanguageContext);
  const { language } = lng;

  const [email, setEmail] = useState('');

  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const changeHandler = (event) => {
    setEmail(event.target.value);
  };

  const submitCustomerHandler = async (event) => {
    event.preventDefault();
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/square`,
        'POST',
        JSON.stringify({
          email: email,
        }),
        {
          'Content-Type': 'application/json',
        }
      );

      alert('success');
    } catch (err) {}
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <div className={`newsletter ${className}`}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h4 className="newsletter__title">
          {language === 'en'
            ? 'get exclusive offers and newsletters'
            : '特別オファーやニュースレターを受け取る'}
        </h4>
        <form onSubmit={submitCustomerHandler} className="newsletter__form">
          <div className="newsletter__form-control">
            <input
              type="email"
              id="email"
              placeholder={
                language === 'en'
                  ? 'ENTER YOUR EMAIL'
                  : 'メールアドレスを入力して下さい'
              }
              onChange={changeHandler}
              value={email}
              className="newsletter__input"
            />
            <button type="submit" className="newsletter__btn">
              &rarr;
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default Newsletter;
